import { TextField } from "@/components/ui/TextField"
import { InputHTMLAttributes } from "react"
import { Path, UseFormRegister } from "react-hook-form"

/** react-hook-form adapter over TextField; the id is always the legacy `name + label` (labels and anchors rely on it). */
export default function BaseInput<T extends Record<string, unknown>>({
  name,
  label,
  error,
  registerAction,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, "name" | "size" | "prefix"> & {
  name: string
  label: string
  error: boolean
  registerAction: UseFormRegister<T>
}) {
  return (
    <TextField
      {...props}
      {...registerAction(name as Path<T>, { required: false })}
      id={name + label}
      invalid={error}
    />
  )
}
